import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';

Vue.use(ElementUI);

import './assets/css/main.css'

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
